import arrayMove from 'array-move';

const addQuestion = (state, action) => {
	const { question, pageId, parentId, index } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		questionPages: state.questionPages.map((page) => {
			if (page.questionPageId === pageId) {
				return {
					...page,
					questions: parentId
						? page.questions.map((q) => {
								if (q.id === parentId) {
									return {
										...q,
										children: arrayMove(
											[
												...q.children,
												{
													...question,
													key: !q.children.length,
													isMultipageChild: q.controlType === 'MultiPage',
													isMultiquestionChild:
														q.controlType === 'MultiPage' ||
														q.controlType === 'Table' ||
														q.controlType === 'TableControl',
													isTableChild:
														q.controlType === 'Table' ||
														q.controlType === 'TableControl',
												},
											],
											-1,
											index !== undefined ? index : -1,
										),
									};
								}

								return q;
							})
						: arrayMove(
								[
									...page.questions,
									{
										...question,
										isMultipage: question.controlType === 'MultiPage',
										isMultiquestion:
											question.controlType === 'MultiPage' ||
											question.controlType === 'Table' ||
											question.controlType === 'TableControl',
										isTable:
											question.controlType === 'Table' ||
											question.controlType === 'TableControl',
									},
								],
								-1,
								index !== undefined ? index : -1,
							),
				};
			}

			return page;
		}),
	};
};

const addRiskGroup = (state, action) => {
	const { index, riskGroup } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		riskGroups:
			index !== undefined
				? arrayMove([...state.riskGroups, riskGroup], -1, index)
				: [...state.riskGroups, riskGroup],
	};
};

const deletePage = (state, action) => {
	const { pageId } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		questionPages: state.questionPages.filter(
			(page) => page.questionPageId !== pageId,
		),
	};
};

const deleteQuestion = (state, action) => {
	const { pageId, parentId, questionId } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		questionPages: state.questionPages.map((page) => {
			if (page.questionPageId === pageId) {
				if (parentId) {
					return {
						...page,
						questions: page.questions.map((question) => {
							if (question.id === parentId) {
								return {
									...question,
									children: question.children.filter(
										(child) => child.id !== questionId,
									),
								};
							}
							return question;
						}),
					};
				}

				return {
					...page,
					questions: page.questions.filter(
						(question) => question.id !== questionId,
					),
				};
			}

			return page;
		}),
	};
};

const deleteRiskGroup = (state, action) => {
	const { id } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		riskGroups: state.riskGroups.filter((r) => r.id !== id),
	};
};

const resetExpandedPages = (state) => ({ ...state, expandedPages: {} });

const resetExpandedQuestions = (state) => ({ ...state, expandedQuestions: {} });

const setActiveQuestionSet = (state, action) => {
	const { activeQuestionSet } = action.payload;

	return { ...state, activeQuestionSet };
};

const setActiveView = (state, action) => {
	const { activeView } = action.payload;

	return { ...state, activeView };
};

const setComparisonQuestionSet = (state, action) => {
	const { comparisonQuestionSet } = action.payload;

	return { ...state, comparisonQuestionSet };
};

const setInterfaceAccessExpiry = (state, action) => {
	const { interfaceAccessExpiry } = action.payload;

	return { ...state, interfaceAccessExpiry };
};

const setInterfaceAccessId = (state, action) => {
	const { interfaceAccessId } = action.payload;

	return { ...state, interfaceAccessId };
};

const setIsAppLoading = (state, action) => {
	const { isAppLoading } = action.payload;

	return { ...state, isAppLoading };
};

const setIsDocumentsLoading = (state, action) => {
	const { isDocumentsLoading } = action.payload;

	return { ...state, isDocumentsLoading };
};

const setIsEditorLoading = (state, action) => {
	const { isEditorLoading } = action.payload;

	return { ...state, isEditorLoading };
};

const setIsInsurersLoading = (state, action) => {
	const { isInsurersLoading } = action.payload;

	return { ...state, isInsurersLoading };
};

const setIsLookupsLoading = (state, action) => {
	const { isLookupsLoading } = action.payload;

	return { ...state, isLookupsLoading };
};

const setIsPublishing = (state, action) => {
	const { isPublishing } = action.payload;

	return { ...state, isPublishing };
};

const setIsQuestionSetsLoading = (state, action) => {
	const { isQuestionSetsLoading } = action.payload;

	return { ...state, isQuestionSetsLoading };
};

const setIsInterfaceLocked = (state, action) => {
	const { isInterfaceLocked } = action.payload;

	return { ...state, isInterfaceLocked };
};

const setIsSaving = (state, action) => {
	const { isSaving } = action.payload;

	return { ...state, isSaving };
};

const setIsSchemeDirty = (state, action) => {
	const { isSchemeDirty } = action.payload;

	return { ...state, isSchemeDirty };
};

const setIsSourceEditorDirty = (state, action) => {
	const { isSourceEditorDirty } = action.payload;

	return { ...state, isSourceEditorDirty };
};

const setPageIsExpanded = (state, action) => {
	const { id, isExpanded } = action.payload;

	return {
		...state,
		expandedPages: { ...state.expandedPages, [id]: isExpanded },
	};
};

const setQuestionIsExpanded = (state, action) => {
	const { id, isExpanded } = action.payload;

	return {
		...state,
		expandedQuestions: { ...state.expandedQuestions, [id]: isExpanded },
	};
};

const setSchemeData = (state, action) => {
	const { schemeData } = action.payload;

	return { ...state, schemeName: schemeData.name };
};

const setSchemeDocuments = (state, action) => {
	const { documents } = action.payload;

	return { ...state, documents };
};

const setSchemeId = (state, action) => {
	const { schemeId } = action.payload;

	return { ...state, schemeId };
};

const setSchemeInsurers = (state, action) => {
	const { insurers } = action.payload;

	return { ...state, insurers };
};

const setSchemeLookups = (state, action) => {
	const { lookups } = action.payload;

	return { ...state, lookups };
};

const setSchemeQuestionSetData = (state, action) => {
	const { schemeQuestionSetData } = action.payload;

	return { ...state, ...schemeQuestionSetData };
};

const setSchemeQuestionSetDataComparison = (state, action) => {
	const { comparisonQuestionSetData } = action.payload;

	return { ...state, comparisonQuestionSetData };
};

const setSchemeQuestionSets = (state, action) => {
	const { schemeQuestionSets } = action.payload;

	return { ...state, questionSets: schemeQuestionSets };
};

const setSelectedPage = (state, action) => {
	const { pageId } = action.payload;

	return { ...state, activeView: 'mainEditor', selectedPage: pageId };
};

const setSourceEditorJson = (state, action) => {
	const { sourceEditorJson } = action.payload;

	return { ...state, sourceEditorJson };
};

const setSourceEditorJsonError = (state, action) => {
	const { sourceEditorJsonError } = action.payload;

	return { ...state, sourceEditorJsonError };
};

const setSourceEditorValidationErrors = (state, action) => {
	const { sourceEditorValidationErrors } = action.payload;

	return { ...state, sourceEditorValidationErrors };
};

const updatePage = (state, action) => {
	const { page } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		questionPages: state.questionPages.map((p) => {
			if (p.questionPageId === page.questionPageId) {
				return { ...page, isDirty: true };
			}

			return p;
		}),
	};
};

const updatePageQuestions = (state, action) => {
	const { pageId, questions } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		questionPages: state.questionPages.map((page) => {
			if (pageId === page.questionPageId) {
				return { ...page, questions };
			}

			return page;
		}),
	};
};

const updatePages = (state, action) => {
	const { pages } = action.payload;

	return { ...state, isSchemeDirty: true, questionPages: pages };
};

const updateQuestion = (state, action) => {
	const { question: updatedQuestion, pageId, parentId } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		questionPages: state.questionPages.map((page) => {
			if (page.questionPageId === pageId) {
				if (parentId) {
					return {
						...page,
						questions: page.questions.map((question) => {
							if (question.id === parentId) {
								return {
									...question,
									children: question.children.map((child) => {
										if (child.id === updatedQuestion.id) {
											return {
												...updatedQuestion,
												isBulkAdded: false,
												isDirty: true,
											};
										}

										return child;
									}),
								};
							}

							return question;
						}),
					};
				}

				return {
					...page,
					questions: page.questions.map((question) => {
						if (question.id === updatedQuestion.id) {
							return {
								...updatedQuestion,
								isBulkAdded: false,
								isDirty: true,
								isMultipage: updatedQuestion.controlType === 'MultiPage',
								isMultiquestion:
									updatedQuestion.controlType === 'MultiPage' ||
									updatedQuestion.controlType === 'Table' ||
									updatedQuestion.controlType === 'TableControl',
								isTable:
									updatedQuestion.controlType === 'Table' ||
									updatedQuestion.controlType === 'TableControl',
							};
						}

						return question;
					}),
				};
			}

			return page;
		}),
	};
};

const updateRiskGroup = (state, action) => {
	const { riskGroup } = action.payload;

	return {
		...state,
		isSchemeDirty: true,
		riskGroups: state.riskGroups.map((r) =>
			r.id === riskGroup.id ? { ...riskGroup, isDirty: true } : r,
		),
	};
};

const updateRiskGroups = (state, action) => {
	const { riskGroups } = action.payload;

	return { ...state, isSchemeDirty: true, riskGroups };
};

const updateSearchTerm = (state, action) => {
	const { searchTerm } = action.payload;

	return { ...state, searchTerm };
};

export default {
	ADD_QUESTION: addQuestion,
	ADD_RISK_GROUP: addRiskGroup,
	DELETE_PAGE: deletePage,
	DELETE_QUESTION: deleteQuestion,
	DELETE_RISK_GROUP: deleteRiskGroup,
	RESET_EXPANDED_PAGES: resetExpandedPages,
	RESET_EXPANDED_QUESTIONS: resetExpandedQuestions,
	SET_ACTIVE_QUESTION_SET: setActiveQuestionSet,
	SET_ACTIVE_VIEW: setActiveView,
	SET_COMPARISON_QUESTION_SET: setComparisonQuestionSet,
	SET_INTERFACE_ACCESS_EXPIRY: setInterfaceAccessExpiry,
	SET_INTERFACE_ACCESS_ID: setInterfaceAccessId,
	SET_IS_APP_LOADING: setIsAppLoading,
	SET_IS_DOCUMENTS_LOADING: setIsDocumentsLoading,
	SET_IS_EDITOR_LOADING: setIsEditorLoading,
	SET_IS_INSURERS_LOADING: setIsInsurersLoading,
	SET_IS_INTERFACE_LOCKED: setIsInterfaceLocked,
	SET_IS_LOOKUPS_LOADING: setIsLookupsLoading,
	SET_IS_PUBLISHING: setIsPublishing,
	SET_IS_QUESTION_SETS_LOADING: setIsQuestionSetsLoading,
	SET_IS_SAVING: setIsSaving,
	SET_IS_SCHEME_DIRTY: setIsSchemeDirty,
	SET_IS_SOURCE_EDITOR_DIRTY: setIsSourceEditorDirty,
	SET_PAGE_IS_EXPANDED: setPageIsExpanded,
	SET_QUESTION_IS_EXPANDED: setQuestionIsExpanded,
	SET_SCHEME_DATA: setSchemeData,
	SET_SCHEME_DOCUMENTS: setSchemeDocuments,
	SET_SCHEME_ID: setSchemeId,
	SET_SCHEME_INSURERS: setSchemeInsurers,
	SET_SCHEME_LOOKUPS: setSchemeLookups,
	SET_SCHEME_QUESTION_SET_DATA: setSchemeQuestionSetData,
	SET_SCHEME_QUESTION_SET_DATA_COMPARISON: setSchemeQuestionSetDataComparison,
	SET_SCHEME_QUESTION_SETS: setSchemeQuestionSets,
	SET_SELECTED_PAGE: setSelectedPage,
	SET_SOURCE_EDITOR_JSON: setSourceEditorJson,
	SET_SOURCE_EDITOR_JSON_ERROR: setSourceEditorJsonError,
	SET_SOURCE_EDITOR_VALIDATION_ERRORS: setSourceEditorValidationErrors,
	UPDATE_PAGE: updatePage,
	UPDATE_PAGE_QUESTIONS: updatePageQuestions,
	UPDATE_PAGES: updatePages,
	UPDATE_QUESTION: updateQuestion,
	UPDATE_RISK_GROUP: updateRiskGroup,
	UPDATE_RISK_GROUPS: updateRiskGroups,
	UPDATE_SEARCH_TERM: updateSearchTerm,
};
